<svelte:options tag={null} />

<script lang="ts">
  import type { BreadcrumbItems } from './breadcrumb.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let items: string;
  export let dark = false;
  export let responsive = false;
  export let nopadding: boolean | string = false;
  let eventHandler = new EventHandler();

  $: parseItems = items ? (JSON.parse(items) as BreadcrumbItems[]) : [];
  $: noPadding = nopadding && nopadding !== 'false';
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
</script>

<nav
  class="mc-breadcrumb {responsive ? ' mc-breadcrumb--responsive' : ''}{dark
    ? ' mc-breadcrumb--dark'
    : ''} {userClass}"
  class:mc-breadcrumb--no-padding={noPadding}
  aria-label="Breadcrumb"
  {...attributes}
>
  <ul class="mc-breadcrumb__container">
    {#each parseItems as item, i}
      <li class="mc-breadcrumb__item{item.isActive ? ' is-active' : ''}">
        {#if i !== parseItems.length - 1}
          <a
            href={item.href}
            class="mc-link mc-link--s{dark ? ' mc-link--light' : ''}"
            on:click={() => eventHandler.dispatch('link-clicked', item)}
          >
            {item.text}
          </a>
        {:else}
          <span
            class="mc-link mc-link--s mc-breadcrumb__current{dark
              ? ' mc-link--light'
              : ''}"
          >
            {item.text}
          </span>
        {/if}
      </li>
    {/each}
  </ul>
</nav>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.links';
  @import '@mozaic-ds/styles/components/_c.breadcrumb';
</style>
